// messagecopy — pure text-builders for copying a query message-log row to the
// clipboard. No DOM / Solid imports so it's unit-testable in plain Node; the
// actual clipboard write + toast live in components/MessageRow.jsx.
//
// A message `m` is one of:
//   { kind: 'statement', status: 'running'|'ok'|'interrupted'|'error',
//     sql?, name?, result?, durationMs?, at, warnings? }
//   { kind: 'ok'|'error'|'info', text, at }

// messageText is the plain-text form of a whole message. For a statement that's
// the SQL plus its outcome line (the outcome IS the error when it failed); for a
// plain info/ok/error row it's just the row's text.
export function messageText(m) {
  if (!m) return '';
  if (m.kind !== 'statement') return m.text || '';
  const lines = [];
  if (m.name) lines.push(`-- @${m.name}`);
  if (m.sql) lines.push(m.sql);
  if (m.status === 'running') {
    lines.push('running…');
  } else if (m.result != null && m.result !== '') {
    lines.push(m.durationMs != null ? `${m.result} · ${m.durationMs}ms` : String(m.result));
  }
  return lines.join('\n');
}

// errorText returns just the error for a message, or '' when it isn't an error
// (so a host can disable "Copy error"). A failed statement carries its error in
// `result`; a plain error row carries it in `text`.
export function errorText(m) {
  if (!m) return '';
  if (m.kind === 'statement' && m.status === 'error') return m.result || '';
  if (m.kind === 'error') return m.text || '';
  return '';
}
